import { render, staticRenderFns } from "./Default-Layout.vue?vue&type=template&id=497eab3d"
import script from "./Default-Layout.vue?vue&type=script&lang=js"
export * from "./Default-Layout.vue?vue&type=script&lang=js"
import style0 from "./Default-Layout.vue?vue&type=style&index=0&id=497eab3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports